import React, { memo } from "react";
import ReactHlsPlayer from "react-hls-player";

const HeroVideoPlayer = memo(({ video }) => {
  const settings = (video && video.video_settings_group) || {};
  return (
    <ReactHlsPlayer
      src={`https://customer-h01ihdmepkho4cwk.cloudflarestream.com/${video.video_id}/manifest/video.m3u8`}
      poster={`https://customer-h01ihdmepkho4cwk.cloudflarestream.com/${video.video_id}/thumbnails/thumbnail.jpg?time=&height=600`}
      autoPlay={!!settings.video_autoplay}
      controls={!!settings.video_controls}
      muted={!!settings.video_muted}
      loop={!!settings.video_loop}
      width="100%"
      height="100%"
      style={{
        objectFit: "cover",
      }}
      playsInline
    />
  );
});

export default HeroVideoPlayer;



// WEBPACK FOOTER //
// ./src/components/Hero/partials/HeroVideoPlayer.js